module.exports = __webpack_public_path__ + "media/images/countryrect/cl-75aeb79836474d1ed51b1874ca70284c.svg";